<template>
  <button
    :class="computedClass"
    :style="{ '--disable-opacity': disableOpacity }"
  >
    <IconChevronLeft
      v-if="direction === 'slidePrev'"
      :width="40"
      :height="40"
    />
    <IconChevronRight
      v-if="direction === 'slideNext'"
      :width="40"
      :height="40"
    />
  </button>
</template>

<script setup lang="ts">
import { useCssModule } from 'vue'

const $style = useCssModule()

const props = defineProps<{
  direction: 'slidePrev' | 'slideNext'
  disabled?: boolean
  disableOpacity?: number
}>()

const computedClass = computed(() => ({
  [$style.button]: true,
  [$style.isDisabled]: props.disabled,
}))
</script>

<style lang="scss" module>
.button {
  border: 0;
  padding: 0;
  margin: 0;
  background: none;
  opacity: 0.7;

  &:hover {
    opacity: 1;
  }
}

.isDisabled {
  opacity: var(--disable-opacity, 0.3);
  pointer-events: none;
}
</style>
